import {ApiClient} from '@hconnect/apiclient'
import {AuthProvider} from '@hconnect/login'
import {ThemeSettingsProvider} from '@hconnect/uikit'
import {UpmPlantsProvider} from '@hconnect/upm'
import {FundamentalContextProvider, ThemeProvider, ToastContainer} from '@hm/fundamental'

import {ThemeInitializer} from '../Components/Base/ThemeInitializer'
import {getStoredThemeMode, persistThemeMode} from '../Components/Base/initializeFundamentalTheme'
import {GlobalErrorBoundary} from '../Components/errorBoundaries/GlobalErrorBoundary'
import {useHproduceDomainOverride} from '../hooks/useHproduceDomainOverride'

import {SuiteQueryProvider} from './SuiteQueryProvider'
import '../index.css'

const HproduceDomainOverride: React.FC<{children: React.ReactNode}> = ({children}) => {
  useHproduceDomainOverride()
  return <>{children}</>
}

export const GlobalProviders: React.FC<{children: React.ReactNode}> = ({children}) => {
  return (
    <FundamentalContextProvider>
      <ThemeSettingsProvider
        initialThemeMode={getStoredThemeMode()}
        onThemeModeChange={persistThemeMode}
      >
        <ThemeProvider>
          <ThemeInitializer />
          <GlobalErrorBoundary>
            <ToastContainer />
            <SuiteQueryProvider>
              <AuthProvider>
                <HproduceDomainOverride>
                  <UpmPlantsProvider api={ApiClient.axiosInstance}>{children}</UpmPlantsProvider>
                </HproduceDomainOverride>
              </AuthProvider>
            </SuiteQueryProvider>
          </GlobalErrorBoundary>
        </ThemeProvider>
      </ThemeSettingsProvider>
    </FundamentalContextProvider>
  )
}
